import { Program } from '@/models';
import { AccountDetector } from '.';

export const programDetector: AccountDetector = async (account, next) => {
  if (!account.accountInfo.executable) return next(account);
  return next(new Program(account.context, account.owner));
};
